import React, {Component} from "react";
import {getInfo} from "../redux/actions/user";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";

class IsAuth extends Component {
	componentWillMount() {
		this.props.onGetInfoUser();
	}

	render() {
		if (!this.props.user.login.auth) {
			return <Redirect to={'/auth'}/>
		}

		return '';
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({
		onGetInfoUser : () => {
			dispatch(getInfo());
		}
	})
)(IsAuth);


// WEBPACK FOOTER //
// ./src/app/components/IsAuth.js